module.exports = __webpack_public_path__ + "img/consultoria2_4-3_682.fc97f34e.webp";